import UserSearch from '../components/users/UserSearch'
import UserResults from '../components/users/UserResults'

const Home = () => {
  return (
    <>
      <UserSearch />
      <UserResults />
    </>
  )
}

export default Home
